module.exports = __webpack_public_path__ + "media/fonts/suisse-intl/SuisseIntl-Light-WebM-ca930ad1b23ba770eae8de067212cb2c.woff2";